import { render, staticRenderFns } from "./EditShangbiao.vue?vue&type=template&id=67bfa73b&scoped=true&"
import script from "./EditShangbiao.vue?vue&type=script&lang=js&"
export * from "./EditShangbiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bfa73b",
  null
  
)

export default component.exports